



















































































import Vue from 'vue';
import pipeline from '@/pipeline';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BackButton from '@/components/BackButton.vue';
import EssayLoading from '@/components/EssayLoading.vue';
import Modal from '@/components/Modal/Modal.vue';
import VueMarkdown from 'vue-markdown';
import Checkbox from '@/components/Checkbox.vue';
import BottomButton from '@/components/BottomButton.vue';
import EssaySendForm, {
  EssaySendFormEvent,
  MIN_ESSAY_WORDS,
} from '@/components/forms/EssaySendForm.vue';
import EssaySendFileForm, {
  EssaySendFileFormEvent,
} from '@/components/forms/EssaySendFileForm.vue';
import ModalSupportText from '@/components/Modal/ModalSupportText.vue';
import { EssaySupportText, EssayTheme } from '@/store/modules/essay/state';
import { Tabs, Tab, Button, Icon, Toast } from '@descomplica/vue-components';
import i18n from '@/i18n';
import { countWords } from '@/helpers/string';
import { AnalyticsActions } from '@/store/modules/analytics/actions';

export default Vue.extend({
  components: {
    Button,
    BackButton,
    PipelineMenuWrapper,
    VueMarkdown,
    Checkbox,
    BottomButton,
    EssaySendForm,
    EssaySendFileForm,
    ModalSupportText,
    Modal,
    Tabs,
    Tab,
    Icon,
    EssayLoading,
    Toast,
  },
  data() {
    return {
      showToast: false,
      uploadType: 'text',
      isModalVisible: false,
      isLoadingEnabled: false,
      hasAcceptedToS: this.$store.getters.essay?.hasAcceptedToS,
      isReadyForUpload: false,
      essay: {
        title: this.$store.getters.essay?.title || '',
        text: this.$store.getters.essay?.text || '',
        wordCount: countWords(this.$store.getters.essay?.text),
        document: this.$store.getters.essay?.document || {},
      },
      tosLink: process.env.VUE_APP_DESCOMPLICA_TOS_LINK,
    };
  },
  computed: {
    admissionId(): number {
      return this.$store.getters.admissionId;
    },
    evaluationStatus(): string {
      return this.$store.getters.evaluationStatus;
    },
    essayTheme(): EssayTheme {
      return this.$store.getters.selectedEssayTheme;
    },
    supportTexts(): EssaySupportText[] {
      return (this.$store.getters.selectedEssayTheme?.supportTexts || [])
        .slice()
        .sort((prev: EssaySupportText, next: EssaySupportText) => {
          if (prev.position === next.position) return 0;
          if (prev.position > next.position) return 1;
          return -1;
        });
    },
    isFinishEnabled(): boolean {
      return this.isEssayFilled && this.hasAcceptedToS && !this.isLoadingEnabled;
    },
    isEssayFilled(): boolean {
      return Boolean(
        (this.uploadType === 'text' &&
          this.essay.title &&
          this.essay.text &&
          this.essay.wordCount >= MIN_ESSAY_WORDS) ||
          (this.uploadType === 'file' && this.essay.document.dataUrl),
      );
    },
  },
  created() {
    this.$store.dispatch('PULL_ESSAY_THEME_DETAILS');
  },
  methods: {
    toggleModalHandler() {
      this.isModalVisible = !this.isModalVisible;
    },
    tosHandler(event: any) {
      this.hasAcceptedToS = event.target.checked;
    },
    async finishHandler() {
      if (this.isLoadingEnabled) return;

      this.isLoadingEnabled = true;
      try {
        await this.$store.dispatch('UPLOAD_ESSAY', {
          ...this.essay,
          uploadType: this.uploadType,
          admissionId: this.admissionId,
        });
        await this.$store.dispatch('UPDATE_ESSAY', {
          essay: { ...this.essay, hasAcceptedToS: this.hasAcceptedToS },
        });

        const fileMimeType: string = this.essay.document?.dataUrl?.split(';')[0] || '';

        this.$store.dispatch(AnalyticsActions.ESSAY_EVALUATION_SENT, {
          uploadType: this.uploadType,
          fileMimeType,
        });

        await this.$store.dispatch('PULL_EVALUATION_STATUS');

        pipeline.next({ status: this.evaluationStatus });
      } catch {
        this.showToast = true;

        setTimeout(() => {
          this.showToast = false;
        }, 3000);
      } finally {
        this.isLoadingEnabled = false;
      }
    },
    inputHandler(typedEssay: EssaySendFormEvent) {
      this.essay = { ...this.essay, ...typedEssay };
    },
    uploadHandler(toUpload: EssaySendFileFormEvent) {
      this.isReadyForUpload = false;
      const document = {
        name: toUpload.fileName,
        dataUrl: toUpload.fileDataUrl,
      };

      this.essay = { ...this.essay, document };

      if (toUpload.fileDataUrl) {
        this.isReadyForUpload = true;
      }
    },
    async deleteHandler() {
      this.isReadyForUpload = false;
      await this.$store.dispatch('DELETE_ESSAY_BY_FILE');
      this.essay.document = this.$store.getters.essay.document;
    },
    toggleUploadType(tabName: string) {
      this.uploadType = tabName === i18n.t('essayStartWrite') ? 'text' : 'file';
    },
  },
});
